import useViewportTier from './useViewportTier';

/** True at or above the `m` breakpoint (>=1024px). Aligned to the theme breakpoints. */
export default function useIsDesktop() {
  return useViewportTier() === 'desktop';
}
